<template>
    <div>
        <b-modal
            ref="login-cadastro"
            size="xl"
            id="modal-consulta-login"
            :body-class="(step==1?'verificao-banner': '')"
            hide-footer
            >
            <div align="center">
                <div :class="'verificacao verificacao-banner align-center justify-content-center flex-column' + (step==1?' d-flex': ' d-none')">
                    <img  @click="step++" class="modal-consulta-login-banner" src="~@/assets/imgs/modal-consulta-login-01.jpg"/>
                </div>
                <div :class="'verificacao verificacao-text-mobile align-center justify-content-center flex-column' + (step==1?' d-flex': ' d-none')">
                    <span><b>⚠ Atenção, Mudança Importante a Caminho! ⚠</b></span>
                    <span>
                        <br>
                        Olá ! Temos uma novidade importante que queremos compartilhar com você. 
                        Para garantir ainda mais a segurança dos nossos usuários, a partir de 15/08/2023, a Consulta Gratuita de Protesto exigirá que você faça o login na Cenprot.
                    </span>
                    <span>
                        <br>
                        Essa é uma maneira de garantirmos que seus dados estarão ainda mais protegidos enquanto você aproveita nossos serviços. 
                        Mas não se preocupe, se ainda não tem uma conta conosco, o processo é super rápido e simples! 🚀

                    </span>
                    <span>
                        <br>
                        👥 Não é cadastrado na Cenprot? É fácil resolver! Convidamos você a se cadastrar gratuitamente. Assim, você poderá continuar aproveitando a Consulta Gratuita de Protesto com total segurança, além de todas as outras vantagens que a Cenprot oferece.
                        
                        <br>
                        <br>
                            Clique no botão abaixo e junte-se a nós agora mesmo! Estamos ansiosos para te receber.

                    </span>
                    <!-- <span><br>Para sua segurança e proteção dos seus dados, para realizar a Consulta Gratuita de Protesto será necessário estar cadastrado no portal da Cenprot Nacional. Caso você já tenha um cadastro, realize o login a seguir.</span> -->
                    <b-button class="btn-continuar-verificacao" @click="step++">Continuar</b-button>
                </div>
                <b-tabs v-show="step==2" content-class="login-cadastr-tabs">
                    <b-tab title="Já sou cadastrado" active>
                        <cardlogin :cardStyle="'cardlogin-modal bg-white'" :pesquisa="true" @loginpesquisa="retorno_login"  />
                    </b-tab>
                    <b-tab title="Cadastro Simplificado">
                        <cadastrosimples @cadastropesquisa="retorno_cadastro" />
                    </b-tab>
                </b-tabs>
            </div>
        </b-modal>
        <b-modal
            ref="modalInstrumento"
            size="xl"
            scrollable
            title="Resultado"
            id="modal-dialog"
            >
            <object width="100%" height="500" type="application/pdf" :data=this.pdf></object>
        </b-modal>

        <b-modal ref="modalErro" title="Atenção">Consulta Bloqueada</b-modal>
        <div :class="'loading ' + (loading?'d-flex':'d-none')">
            <div :class="'box-loading ' + (loading?'d-flex':'d-none')">Processando, aguarde...</div>
            <b-spinner
            variant="primary"
            style="width: 60px; height: 60px"
            label="Large Spinner"
            v-if="loading"
            ></b-spinner>
        </div>
        <div class="container-consultas">
            <div class="container-consultas-column">
                <div class="texto-consulta">
                    <span><img class="seta" src="@/assets/imgs/svg/arrow_home_consulta.svg" />Pesquisar <strong>CPF ou CNPJ</strong></span>
                    <span>Consulta Gratuita de Protesto em todo o Brasil</span>
                </div>
                <div class="boxInput">
                    <the-mask id="input_cpf_cnpj" :class="showError?'is-invalid':''" :mask="['###.###.###-##', '##.###.###/####-##']" placeholder="CPF/CNPJ" v-model="cpf_cnpj" pattern="\d*" />
                    <button type="button" class="bt-consultar"  @click="executaBusca()">{{ isSmallScreen ? '' : 'Consultar' }}<img class="icone-boltao-consulta" src="@/assets/imgs/svg/lupa_branca.svg"></button>
                </div>
                <span id="errorMsg" ref="inputError" :class="showError?'d-flex':''">{{errorMessage}}</span>
            </div>
        </div>
        
    </div>
</template>
<script>
import { TheMask } from "vue-the-mask";
import API from '../../services/api'
import cardlogin from '../login/card_login';
import cadastrosimples from "../cadastro/simples";
import { computed } from "vue";
export default {
    props:['totem'],
    components: {TheMask,cardlogin, cadastrosimples},
    data() {
        return {
            sitekey: process.env.VUE_APP_sitekeyRecaptchaInvisivel,
            mobile: window.innerWidth < 1200,
            cpf_cnpj: "",
            nm_chave:"",
            pdf:"",
            recaptchaToken:'',
            docValidationRegexp: new RegExp(/^(.)\1{1,}$/),
            invalid:false,
            errorMessage:'*Documento inválido',
            showError:false,
            blockConsulta:false,
            troncosBloqueados:['00360305'],
            loading: false,
            step: 2,
        }
    },
    methods: {
        validaDocumento(documento){
            this.invalid = !(documento.length == 11 || documento.length == 14);
            if(!this.invalid){
                this.invalid = this.docValidationRegexp.test(documento);
                if(!this.invalid){
                    switch (documento.length) {
                        case 11: 
                        this.validaCPF(documento); break;
                        case 14: 
                        this.validaCNPJ(documento); break;
                    }
                }
            }
        },
        validaCPF(documento) {
            var Soma = 0, Resto = 0;
            documento = documento.split("");

            // Validação 1o Digito
            for (let i=1; i<=9; i++) Soma += parseInt(documento[i-1]) * (11 - i);
            Resto = (Soma * 10) % 11;
            if ((Resto == 10) || (Resto == 11)) Resto = 0;
            if (Resto != parseInt(documento[9])) return this.invalid = true;

            // Validação 2o Digito
            Soma = 0;
            for (let i = 1; i <= 10; i++) Soma += parseInt(documento[i-1]) * (12 - i);
            Resto = (Soma * 10) % 11;
            if ((Resto == 10) || (Resto == 11))  Resto = 0;
            if (Resto != parseInt(documento[10])) return this.invalid = true;
            return this.invalid = false;
        },
        validaCNPJ(documento) {
            // Valida troncos bloqueados
            this.blockConsulta = this.invalid = (this.troncosBloqueados.includes(documento.substr(0,8)));
            if(this.invalid) return false;

            documento = documento.split("");
            var soma, i, resultado, multiplier, range;

            // Validação 1o Digito
            range = documento.length - 2;
            soma = 0;
            multiplier = range - 7;
            for (i = 0; i < range; i++) {
                soma += documento[i] * multiplier--;
                if (multiplier < 2) multiplier = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if(resultado != documento[12]) return this.invalid = true;

            // Validação 2o Digito
            range++;
            soma = 0;
            multiplier = range - 7;
            for (i = 0; i < range; i++) {
                soma += documento[i] * multiplier--;
                if (multiplier < 2) multiplier = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if(resultado != documento[13]) return this.invalid = true;
            return this.invalid = false;
        },
        // consultar: function() {
        //     this.$refs.invisibleRecaptcha.execute();
        // },
        executaBuscaChave: function (){
            if(this.tok !== '' && this.tok !== undefined) {
                this.tipoServico = 4
                API.get(`VerifInstProt/${this.nm_chave}/${this.tok}/${this.tipoServico}`)
                .then(res => {
                    // console.log(res.data.instrumentoProtesto)
                        if(res.data.result == 1){
                            this.pdf = "data:application/pdf;base64, " +
                            encodeURI(res.data.instrumentoProtesto);
                            this.$refs["modalInstrumento"].show();
                        }else {
                            this.$refs["modalErro"].show();
                        }
                })
                .catch(()=> {
                    alert("Não foi possivel completar a solicitação");
                    this.exibir = false;
                });
            }
        },
        executaBusca: function (){
            var self_router = this.$router;
            var self = this;
            if(this.blockConsulta) {
                this.$refs["modalErro"].show();
                return this.showError = true;
            }
            else if(this.invalid) return this.showError = true;
            else this.showError = false;

            this.$root.isLogged().then( res => {
                setTimeout(() => {
                        this.loading = true;
                        // var xmlhttp = new XMLHttpRequest();
                        // xmlhttp.open("GET", "https://api.ipify.org?format=json");
                        // xmlhttp.send();
                        // xmlhttp.onload = function(e) {
                        //     var info_ip = JSON.parse(xmlhttp.response);
                        //     var maquina_cliente = info_ip['ip'].replaceAll('.','_');
                        // }
                        self_router.push({ name: 'consulta', params: { documento: self.cpf_cnpj, totem: self.totem} });
                    
                }, 1000)  
            }).catch(() => {
                this.$refs["login-cadastro"].show();

            })            
        },
        onVerify: function(response) {
            this.recaptchaToken = response;
            this.resetRecaptcha();
        },
        onExpired: function() {
            this.$refs.invisibleRecaptcha.reset();
        },
        resetRecaptcha() {
            this.$refs.invisibleRecaptcha.reset(); // Direct call reset method
        },
        gerarBoleto() {
            this.$refs.invisibleRecaptcha.execute();
        },
        retorno_login(res){
            if(res.resposta){
                this.loading = true;
                this.$router.push({ name: 'consulta', params: { documento: this.cpf_cnpj, totem: self.totem} });
            }
        },
        retorno_cadastro(res){
            if(res.resposta){
                this.loading = true;
                this.$router.push({ name: 'consulta', params: { documento: this.cpf_cnpj, totem: self.totem} });
            }
        },
    },
    watch:{
        cpf_cnpj(documento){
            if(this.showError) this.showError = false;
            this.validaDocumento(documento)
        }
    },
    computed:{
        isSmallScreen(){
            return window.innerWidth < 600
        }
    }
    
}
</script>
<style scoped>
#errorMsg{display: none;color: #1ACEB5;position: absolute;font: normal normal normal 15px/20px 'Kanit' !important;margin-top: 88px;}
.loading {
    width: 100vw;
    height: 100vh;
    position: fixed;
    background: #000000ab;
    top: 0;
    left: 0;
    z-index: 10000;
    align-items: center;
    justify-content: center;
}
.loading .box-loading{
    width: 150px;
    height: 150px;
    border-radius: 20px;
    background: #ffffff;
    position: fixed;
    text-align: center;
    align-items: end;
    padding: 6px 30px;
    margin-top: 40px;
}

.verificacao{
    /* aviso modelo texto */ 
    /* width:453px; */
    /* padding: 28px 26px 28px 24px; */
    /* aviso modelo imagem */ 
    border-radius: 16px;
    overflow: hidden;
}
.verificacao img{
    cursor: pointer;
}

.btn-continuar-verificacao {
    background: #4780F1 0 0 no-repeat padding-box!important;
    border-radius: 5px !important;
    border: none !important;
    text-align: center;
    font: normal normal 700 15px/20px 'Kanit',sans-serif;
    letter-spacing: 0;
    color: #fff;
    padding: 9px 0;
    margin-top: 66px !important;
    width: 100%;
}


@media (max-width: 991px) {
    .verificacao img{
        width: 1070px;
        align-self: flex-end;
    }
}
@media (max-width: 540px) {
    .verificacao{
        width: 260px;
    }
    .verificacao img{
        display: none;
    }
    .verificacao.verificacao-banner{
        display: none !important;
    }
}
@media (min-width: 541px) {
    .verificacao.verificacao-text-mobile{
        display: none !important;
    }
}
</style>